export default __webpack_public_path__ + "ac2a03743015283caf3d1a868b2d698d.svg";